module.exports = __webpack_public_path__ + "static/media/Uni-recruit.79420c4c.png";